import WorkspaceEmailTemplatesView from '../components/workspace/WorkspaceEmailTemplatesView';

import { useAuthSession } from 'src/auth/hooks/useAuthSession';

const TEMPLATE_EDITOR_ROLES = ['TENANT_OWNER', 'TENANT_ADMIN'];

const WorkspaceEmailTemplatesPage: React.FC = () => {
  const { workspaceContext } = useAuthSession();

  const canView =
    workspaceContext?.roles.some((r) => TEMPLATE_EDITOR_ROLES.includes(r)) ??
    false;

  if (!canView) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm font-medium text-gray-900">Access Denied</p>
        <p className="mt-1 text-sm text-gray-500">
          You do not have permission to manage workspace email templates.
        </p>
      </div>
    );
  }

  if (!workspaceContext?.tenantId) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm font-medium text-gray-900">Workspace Required</p>
        <p className="mt-1 text-sm text-gray-500">
          Select a workspace to manage email templates.
        </p>
      </div>
    );
  }

  return <WorkspaceEmailTemplatesView tenantId={workspaceContext.tenantId} />;
};

export default WorkspaceEmailTemplatesPage;
